// @core/api/endpoints/apikey/list_api_key_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAPIKeyPoliciesResponse,
} from '../../../types/apikey';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/apikey';

/**
 * List API key policies
 * Returns API key policies, optionally filtered by scope entity type.
 */
export async function ListAPIKeyPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAPIKeyPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/api-key-policies`;
  const requestOptions = options;
  return client.get<ListAPIKeyPoliciesResponse>(requestPath, { ...requestOptions, params });
}
